var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "38px",
    viewBox: "0 0 39 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B4D63F22-C63D-46F2-9069-2724C0101EFB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-813.000000, -151.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-money",
    transform: "translate(813.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,38 C14.2913672,38 9.39442969,36.0237031 5.71136719,32.4350781 C2.02830469,28.8464531 0,24.0750781 0,19 C0,13.9249219 2.02838086,9.15362109 5.71136719,5.56492188 C9.39435352,1.97622266 14.2913672,0 19.5,0 C24.7086328,0 29.6055703,1.97629688 33.2886328,5.56492188 C36.9716953,9.15354687 39,13.9249219 39,19 C39,24.0750781 36.9716191,28.8463789 33.2886328,32.4350781 C29.6056465,36.0237773 24.7086328,38 19.5,38 Z M19.5,2.375 C10.091707,2.375 2.4375,9.83294531 2.4375,19 C2.4375,28.1670547 10.091707,35.625 19.5,35.625 C28.908293,35.625 36.5625,28.1670547 36.5625,19 C36.5625,9.83294531 28.908293,2.375 19.5,2.375 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.8 C18.162,17.8 16.6666667,16.4542 16.6666667,14.8 C16.6666667,13.1458 18.162,11.8 20,11.8 C21.838,11.8 23.3333333,13.1458 23.3333333,14.8 C23.3333333,15.4627 23.93025,16 24.6666667,16 C25.4030833,16 26,15.4627 26,14.8 C26,12.234925 24.0018333,10.0834 21.3333333,9.53605 L21.3333333,8.2 C21.3333333,7.5373 20.7364167,7 20,7 C19.2635833,7 18.6666667,7.5373 18.6666667,8.2 L18.6666667,9.53605 C15.9981667,10.0834 14,12.234925 14,14.8 C14,17.777575 16.6915833,20.2 20,20.2 C21.838,20.2 23.3333333,21.5458 23.3333333,23.2 C23.3333333,24.8542 21.838,26.2 20,26.2 C18.162,26.2 16.6666667,24.8542 16.6666667,23.2 C16.6666667,22.5373 16.06975,22 15.3333333,22 C14.5969167,22 14,22.5373 14,23.2 C14,25.765075 15.9981667,27.9166 18.6666667,28.46395 L18.6666667,29.8 C18.6666667,30.4627 19.2635833,31 20,31 C20.7364167,31 21.3333333,30.4627 21.3333333,29.8 L21.3333333,28.46395 C24.0018333,27.9166 26,25.765075 26,23.2 C26,20.222425 23.3084167,17.8 20,17.8 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.16a00cada894cd00c605b9565afa609c.svg";
export { ForwardRef as ReactComponent };